module.exports = __webpack_public_path__ + "static/media/IKEGAI.0a6ac98d.webm";